import React, {useCallback, useEffect, useState} from "react";
import "leaflet/dist/leaflet.css";

import {MapContainer} from "react-leaflet";
import "../layer_control_tiles.css";
import TileLayersWithControl from "../TileLayersWithControl";
import {debounce} from "../../../utils/debounce";


const useMapResize = (mapRef) => {
    const [mapSize, setMapSize] = useState({ width: 0, height: 0 });

    const handleResize = useCallback(
        debounce((mapInstance) => {
            if (mapInstance) {
                mapInstance.invalidateSize({
                    animate: true,
                    pan: false
                });
            }
        }, 300), // 300ms di debounce
        []
    );

    useEffect(() => {
        if (!mapRef || !mapRef.current) return;
        const mapElement = mapRef.current.getContainer();

        const resizeObserver = new ResizeObserver((entries) => {
            for (let entry of entries) {
                const { width, height } = entry.contentRect;
                setMapSize({ width, height });
            }
        });

        resizeObserver.observe(mapElement);
        return () => resizeObserver.disconnect();
    }, [mapRef.current]);

    useEffect(() => {
        if (mapRef && mapRef.current) {
            handleResize(mapRef.current);
        }
    }, [mapSize, mapRef, handleResize]);
}


const GeoJSONMap = (props) => {
    const {
        center = [45.6, 9.7],
        zoom = 6,
        mapRef,
        children,
        ...mapContainerProps
    } = props;

    useMapResize(mapRef);

    return <MapContainer ref={mapRef}
                         center={center}
                         zoom={zoom}
                         maxZoom={16}
                         style={{ height: '100%', width: '100%' }}
                         {...mapContainerProps}>
        <TileLayersWithControl />
        {
            children
        }
    </MapContainer>
}

export default GeoJSONMap;